import styled, { css } from 'styled-components';

export const PanelWrapper = styled.div`
  background-color: white;
  border: 1px solid ${props => props.theme.carvana.gray.light};
  border-radius: 8px;
  overflow: hidden;
`;

const panelPadding = '24px';

export const PanelHeaderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  padding: 0 ${panelPadding};
  min-height: 75px;
  width: 100%;
  border-bottom: 1px solid ${props => props.theme.carvana.gray.light};
  padding: 24px;
  gap: 8px;

  ${props => props.errorState === true && css`
    background-color: ${props.theme.carvana.red.primary};
  `}

  ${props => props.completedState === true && css`
    background-color: ${props.theme.carvana.green.primary};
  `}
`;

export const PanelHeader = styled.div`
  font-size: 18px;
  font-weight: 500;
`;

export const PanelSubHeader = styled.div`
  font-size: 16px;
  font-weight: 400;
`;

export const PanelBody = styled.div`
  padding-left: ${panelPadding};
  padding-right: ${panelPadding};
`;
